const MAX_MEMORIES = 50;

function getStorageKey(agentId) {
  return `memory_${agentId}`;
}

function loadMemories(agentId) {
  try {
    const raw = localStorage.getItem(getStorageKey(agentId));
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveMemories(agentId, memories) {
  try {
    localStorage.setItem(getStorageKey(agentId), JSON.stringify(memories));
  } catch {}
}

export function saveMemory(agentId, type, content, tags = []) {
  const memories = loadMemories(agentId);

  memories.unshift({
    id: `mem_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    type,
    content,
    timestamp: Date.now(),
    tags,
  });

  // Cap at MAX_MEMORIES
  if (memories.length > MAX_MEMORIES) {
    memories.length = MAX_MEMORIES;
  }

  saveMemories(agentId, memories);
}

export function getRecentMemories(agentId, n = 5) {
  const memories = loadMemories(agentId);
  return memories.slice(0, n).map((m) => {
    const age = timeAgoShort(m.timestamp);
    return `[${age}] ${m.type}: ${m.content}`;
  });
}

export function getRecentMemoryObjects(agentId, n = 5) {
  return loadMemories(agentId).slice(0, n);
}

export function summarizeMemories(agentId) {
  const memories = loadMemories(agentId);
  if (memories.length === 0) return 'No recent activity.';

  const tasks = memories.filter((m) => m.type === 'task_complete').slice(0, 3);
  const convos = memories.filter((m) => m.type === 'conversation').slice(0, 2);
  const delegations = memories.filter((m) => m.type === 'delegation_received').slice(0, 2);

  const parts = [];
  if (tasks.length) {
    parts.push(`Recently completed: ${tasks.map((t) => t.content).join('; ')}.`);
  }
  if (convos.length) {
    parts.push(`Recent conversations about: ${convos.map((c) => c.content).join(', ')}.`);
  }
  if (delegations.length) {
    parts.push(`Received delegated tasks: ${delegations.map((d) => d.content).join(', ')}.`);
  }

  return parts.join(' ') || 'No recent activity.';
}

function timeAgoShort(ts) {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}
